import {
  CREATE_CONTACT,
  GET_CONTACT_COUNTS,
  GET_DOWNLOADS_LIST,
  SET_FILTER_TYPE,
  GET_COMPANIES_LIST,
  GET_DOWNLOAD_ITEM,
  CREATE_DOWNLOAD_ITEM,
  UPDATE_DOWNLOAD_ITEM,
  GET_CURRENT_MOVIE,
  CLEAR_CURRENT_MOVIE,
  UPDATE_DOWNLOAD,
  SET_FILTER_BUNDLE,
  CREATE_BUNDLE,
  GET_BUNDLE,
  GET_BUNDLE_ITEM_MOVIE,
  GET_COMPANY,
  DELETE_BUNDLE,
  DELETE_DOWNLOAD_ITEM,
  DOWNLOAD_IS_CREATED,
  GET_DOWNLOAD_ITEM_LIST,
  CLEAR_CURRENT_DOWNLOAD_ITEM,
  GENERATE_FREE_DOWNLOAD_ITEM,
  GET_MOVIE_INFO,
  CREATE_MOVIE,
  UPDATE_MOVIE,
  GET_PROFESSIONS_LIST,
  GET_GENRE,
  GET_PROFESSION,
  SET_POSTER_PROPS,
  UPDATE_POSTER,
  DELETE_MOVIE,
  GET_DOWNLOADS_INFINITE_LIST,
  RESET_DOWNLOADS_INFINITE_LIST,
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  labelsList: [],
  filterType: {
    by_name: '',
  },
  movieList: [],
  currentMovie: null,
  totalMovie: null,
  counter: null,
  companiesList: [],
  downloadItems: [],
  downloadItem: null,
  metaMovieList: {},
  filterBundle: {
    by_movie: {
      name: '',
      uid: '',
    },
    by_quality: '',
  },
  bundledList: [],
  bundleItemMovies: [],
  metaBundleItemMovies: {},
  metaBundledList: {},
  company: null,
  isCreatedDwonload: false,
  genresList: [],
  movieInfo: null,
  professionProfile: [],
  professions: [],
  uploadedPoster: null,
  movieInfiniteList: [],
  metaMovieInfiniteList: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_FILTER_TYPE: {
      return {
        ...state,
        filterType: action.payload,
      };
    }

    case GET_COMPANY: {
      return {
        ...state,
        company: action.payload,
      };
    }

    case GET_BUNDLE: {
      return {
        ...state,
        bundledList: action.payload.bundle_items,
        metaBundledList: action.payload.meta,
      };
    }

    case DELETE_BUNDLE: {
      return {
        ...state,
        bundledList: state.bundledList.filter(item => item.id !== action.payload),
      };
    }

    case CREATE_BUNDLE: {
      return {
        ...state,
        bundledList: state.bundledList.concat(action.payload),
      };
    }

    case DELETE_DOWNLOAD_ITEM: {
      return {
        ...state,
        downloadItems: state.downloadItems.filter(item => item.id !== action.payload),
      };
    }

    case GET_BUNDLE_ITEM_MOVIE: {
      return {
        ...state,
        bundleItemMovies: action.payload.download_items,
        metaBundleItemMovies: action.payload.meta,
      };
    }

    case SET_FILTER_BUNDLE: {
      return {
        ...state,
        filterBundle: action.payload,
      };
    }

    case CLEAR_CURRENT_MOVIE: {
      return {
        ...state,
        currentMovie: null,
        downloadItems: [],
      };
    }

    case CLEAR_CURRENT_DOWNLOAD_ITEM: {
      return {
        ...state,
        downloadItem: null,
        downloadItems: [],
      };
    }

    case GET_DOWNLOADS_LIST: {
      return {
        ...state,
        movieList: action.payload.movies,
        metaMovieList: action.payload.meta,
      };
    }

    case GET_DOWNLOADS_INFINITE_LIST: {
      const { movies, meta } = action.payload;

      return {
        ...state,
        movieInfiniteList: state.movieInfiniteList.concat(movies),
        metaMovieInfiniteList: meta,
      };
    }

    case RESET_DOWNLOADS_INFINITE_LIST: {
      return {
        ...state,
        movieInfiniteList: [],
        metaMovieInfiniteList: null,
      }
    }

    case DOWNLOAD_IS_CREATED: {
      return {
        ...state,
        isCreatedDwonload: action.payload,
      };
    }

    case GET_CURRENT_MOVIE: {
      return {
        ...state,
        currentMovie: action.payload,
      };
    }

    case CREATE_CONTACT: {
      let updatedList = state.movieList;
      let updatedCount = state.totalEpisode;
      if (state.filterType.selectedFolder === 'contacts') {
        updatedList = [action.payload, ...updatedList];
        updatedCount = updatedCount + 1;
      }
      return {
        ...state,
        movieList: updatedList,
        totalEpisode: updatedCount,
      };
    }

    case UPDATE_DOWNLOAD: {
      return {
        ...state,
        currentMovie: action.payload,
      };
    }

    case GET_CONTACT_COUNTS: {
      return {
        ...state,
        counter: action.payload,
      };
    }

    case GET_COMPANIES_LIST: {
      return {
        ...state,
        companiesList: action.payload,
      };
    }

    case GENERATE_FREE_DOWNLOAD_ITEM: {
      return {
        ...state,
        downloadItems: state.downloadItems.concat(action.payload.download_items),
      };
    }

    case CREATE_DOWNLOAD_ITEM: {
      return {
        ...state,
        downloadItems: state.downloadItems.concat(action.payload),
      };
    }

    case UPDATE_DOWNLOAD_ITEM: {
      return {
        ...state,
        downloadItems: state.downloadItems.map(item => (item.id === action.payload.id ? action.payload : item)),
      };
    }

    case GET_DOWNLOAD_ITEM: {
      return {
        ...state,
        downloadItem: action.payload,
      };
    }

    case GET_DOWNLOAD_ITEM_LIST: {
      return {
        ...state,
        downloadItems: action.payload.download_items,
      };
    }

    case GET_MOVIE_INFO: {
      return {
        ...state,
        movieInfo: action.payload,
      };
    }

    case CREATE_MOVIE: {
      return {
        ...state,
        movieInfo: action.payload,
      };
    }

    case UPDATE_MOVIE: {
      return {
        ...state,
        movieInfo: action.payload,
      };
    }

    case GET_PROFESSIONS_LIST: {
      return {
        ...state,
        professions: action.payload.professions,
      };
    }

    case GET_PROFESSION: {
      return {
        ...state,
        professionProfile: action.payload,
      };
    }

    case GET_GENRE: {
      return {
        ...state,
        genresList: action.payload.genres,
      };
    }

    case SET_POSTER_PROPS: {
      return {
        ...state,
        posterProps: action.payload,
      };
    }

    case UPDATE_POSTER: {
      return {
        ...state,
        uploadedPoster: action.payload
      }
    }

    case DELETE_MOVIE: {
      return {
        ...state,
        movieList: state.movieList.filter(item => item.uid !== action.payload)
      }
    }

    default:
      return state;
  }
};
